import AbstractSiteApi from '../AbstractSiteApi';

class ResourceApi extends AbstractSiteApi {
    protected endpoint: string = 'resources';

    async getImageByTemplate(file: string, defaultFile: string | null = null): Promise<string> {
        const response = await this.post('/getImage', { filePath: file, defaultFilePath: defaultFile });

        return response?.data ?? '';
    }
}

export default new ResourceApi();
